import { useUserContext } from '../context/auth/UserContext';
import { UserModel,AccessRight } from '../modal/UserAccess';

export const useAccessRights = (pageName: string): AccessRight | null => {
  const { userAccess }: { userAccess: UserModel | null } = useUserContext();

  const getAccessRights = (): AccessRight | null => {
    if (!userAccess?.accessRights) return null;

    // Find access rights for the given page
    const pageAccess = userAccess.accessRights.find((accessRight) => accessRight.pageName === pageName);

    // Return the 0th object of the rights array (if it exists)
    return pageAccess?.rights[0] || null;
  };

  return getAccessRights();
};
